import React from "react"
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';

import SimpleBar from "simplebar-react"
import {useTranslation} from 'react-i18next'
import useStore from 'app/store/store'
import 'simplebar-react/dist/simplebar.min.css';
import './CoursesLegend.scss';

export default function CoursesLegend({filteredCourses, withCheckbox, setFilteredCourses}){
  const {t} = useTranslation();

  const user = useStore((state) => state.user);

  let fAS = "";

  function toggleCourse(course) {
    let filteredCourses_ = [];

    filteredCourses.forEach((x) => {


      if (x.id === course.id && x.visible === "yes"){
        x.visible = "no";
      }else if (x.id === course.id && x.visible === "no"){
        x.visible = "yes";
      }

      filteredCourses_.push(x);

    });


    setFilteredCourses(filteredCourses_);
  }


  return (
    <Box id="js-sel-ab-container" className={"sel-cl-container "}>
      
        {
          withCheckbox && 
          <Typography  sx={{fontSize: 10}} className="center-text  upper">
            {t(`*Core ${user.course}s are selected by default*`)}
          </Typography>
        }

      <SimpleBar  className="h-100 " >
      {
        filteredCourses.map((fc, key)=>{

          return (
            <Grid key={key} className="d-f ai-c " >
              {
                withCheckbox && 
                <Grid><Checkbox onClick={()=>toggleCourse(fc)} checked={fc.visible==="yes"}  /></Grid>
              }
              <Grid className="selected-item">
                <Typography variant="span" sx={{fontSize: 14, fontWeight: 700, color: fc.color}} className={" font-4 js-ab-"+fAS}>
                - ({fc.id}) {fc.name}
                </Typography>
              </Grid>
            
              
            </Grid>
            )
        })
      }
      </SimpleBar>
    </Box>
    )
}